import { useCallback, useEffect, useState, type ReactNode } from "react";
import { me as fetchMe } from "../api/auth";
import { ApiError } from "../api/client";
import { AuthContext } from "../hooks/useCurrentUser";
import type { UserMe } from "../types/user";

interface Props {
  children: ReactNode;
}

export function AuthProvider({ children }: Props) {
  const [user, setUser] = useState<UserMe | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const u = await fetchMe();
      setUser(u);
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        setUser(null);
      } else {
        // 503 (Academy DB not ready) or other — leave user null, log
        console.error("Auth refresh failed", err);
        setUser(null);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return (
    <AuthContext.Provider value={{ user, loading, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
